<template>
  <v-container grid-list-lg>
    <div v-if="!linkNovo">
        <v-text-field 
        label="Termo de Concordância e Veracidade"
        @click='onPickFile'
        v-model='fileName'
        prepend-icon="attach_file"
        ></v-text-field>
        <!-- Hidden -->
        <input
        type="file"
        style="display: none"
        ref="fileInput"
        accept="*/*"
        @change="onFilePicked">
    </div>
    <div v-if="linkNovo">
    Termo de Veracidade :
            <strong>
              <a v-show="linkNovo  && linkNovo != 'Não Encontrado' " @click="baixarArquivo(linkNovo)">
                <v-icon color="blue">attach_file</v-icon>
              </a>
              </strong>
    </div>
    
  </v-container>
</template>


<script>
import fornecedorService from "../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
  export default {
    name: "Upload-Arquivo-SEI",
    props: {//Propriedades que o objeto recebe como parametro
        idFornecedor: null,
        tipoArquivo:null,
    },
    data: () => ({
        fileName: '',
        url: '',
        fileObject: null,
        cardResult: '',
        name: '',
        size: '',
        type: '',
        lastModifiedDate: '',
        loading: false,
        arquivoBase64: null,
        linkNovo:null
    }),
    methods: {
        onPickFile () {
        this.$refs.fileInput.click()
        },
        onFilePicked (event) {
        const files = event.target.files
        if (files[0] !== undefined) {
            this.fileName = files[0].name
            // Check validity of file
            if (this.fileName.lastIndexOf('.') <= 0) {
            return
            }
            // If valid, continue
            const fr = new FileReader()
            fr.readAsDataURL(files[0])
            
            //
            this.arquivoBase64 = fr.result;
            fr.addEventListener('load', () => {
            this.url = fr.result
            this.fileObject = files[0] // this is an file that can be sent to server...
            
            this.enviarArquivoSEI(fr.result, this.fileObject.name);
            })

        } else {
            this.fileName = ''
            this.fileObject = null
            this.url = ''
        }
        },
        enviarArquivoSEI(base64,nomeArquivo){
            let model = {
                        "base64": base64, 
                        "idFornecedor": this.idFornecedor,
                        "tipoArquivo": this.tipoArquivo,
                        "nomeArquivo": nomeArquivo
                        };
                        
        fornecedorService.enviarArquivoSEI(model).then(response => { /*resposta do servico*/
                this.linkNovo = response.data
                this.$removePreload(); /*Ocultar o PreLoad*/
            });

            
        },
        
        baixarArquivo(arquivo) {
        fornecedorService.baixarArquivo(arquivo, this.idFornecedor);
        },
        onUploadSelectedFileClick () {
        this.loading = true
        
        // A file is not chosen!
        if (!this.fileObject) {
            alert('No file!!')
        }
        // DO YOUR JOB HERE with fileObjectToUpload
        // https://developer.mozilla.org/en-US/docs/Web/API/File/File
        this.name = this.fileObject.name
        this.size = this.fileObject.size
        this.type = this.fileObject.type
        this.lastModifiedDate = this.fileObject.lastModifiedDate
        // DO YOUR JOB HERE with fileObjectToUpload

        this.loading = false
        }
    }
  }
</script>